


























































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import CouponItem from '@tencent/wphk-components-wecoupon/components/coupon-item/index.vue';
import PageNav from '@/components/we-coupons/page-nav/index.vue';
import { PageResult } from '@/components/we-coupons/page-nav/business';
import { getFavoritesList } from '@/business/we-coupons/coupon';
import { getListByClassId } from '@tencent/wphk-components-wecoupon/components/mch-coupon-list/business/coupon';
import { CouponInfo } from '@tencent/wphk-components-wecoupon';
import ContentLoadFail from '@/components/we-coupons/content-load-fail/index.vue';
import NoMoreTips from '@/components/we-coupons/no-more-tips/index.vue';
import { biBrow } from '@tencent/fit-bi-sdk';
import { getNextCouponClass } from '@/business/we-coupons/coupon-class';
import { dataLoadCompleteHelper } from './utils/view-helper';
import { NotifyActionRet } from '@/business/we-coupons/coupon-subscribe';
import { getCouponListWithAd, getAdList } from '@/business/we-coupons/ad';
import CouponAd from '@/components/we-coupons/ad/coupon-ad.vue';
import {
  MerchantInfoWithAd,
  CouponAdConf,
  ReceivedCouponListType,
  PositionType,
  MergeCouponListItem,
  AdSet,
} from '@/types/we-coupons';
import { MerchantSubscribe } from '@tencent/wphk-components-merchant-favorites';
import SubscribeDialog from '@/components/we-coupons/subscribe-dialog/index.vue';
import { i18n } from '@/i18n';
import { handleTimeout } from '@/util';
import MerchantItemInfo from '@/components/we-coupons/merchant-item-info.vue';
import { initShare } from '@/views/WeCoupons/utils/view-helper';
import { NS } from '@/components/my-favorites/types';
import { handleCouponShareSetInfo, handleCouponShareShowDialog } from '@tencent/wphk-components-wecoupon/components/share-channel';

@Component({
  components: {
    CouponItem,
    PageNav,
    ContentLoadFail,
    NoMoreTips,
    CouponAd,
    MerchantSubscribe,
    SubscribeDialog,
    MerchantItemInfo,
  },
})
export default class WeCouponsCouponList extends Vue {
  @Ref('pageNav') pageNav!: PageNav<CouponInfo>;
  /**
   * 已领取的优惠券couponId列表
   */
  @Prop({ default: () => [] }) receivedCouponIdList!: ReceivedCouponListType;

  isShow = false;

  /** 广告数组 */
  adList: CouponAdConf[] = [];

  /** 是否加载完成 */
  isComplete = false;
  /** 订阅模板 */
  subTplInfo = [{
    id: 'subc.wecoupon_online_notify',
    tplId: 'Vp0eojT1lEUceQjBZPwMy0LlGMCSaC4_hEDmCdDr9Vs',
  }];
  NS = NS;

  get inputTips() {
    if (this.classId === NS.Favorites) {
      return i18n('收藏的商戶目前暫無優惠，敬請期待');
    }
    return '';
  }
  /**
   * 当前分类ID
   */
  get classId(): string {
    return this.$route.params.classId || '';
  }
  /**
   * 是否有下一分类
   */
  get hasNextClass() {
    return getNextCouponClass(this.classId) !== null;
  }

  /**
   * bi abt 扩展字段
   */
  get biExt() {
    return {
      fclassid: this.classId,
    };
  }

  /** 是否为广告券 */
  isCouponAd(item: MergeCouponListItem): item is AdSet {
    return item.type === PositionType.ad;
  }

  /**
   *  提供查询分页数据方法，供分页组件使用
   */
  async queryCounponList(
    offset: number,
    limit: number,
  ): Promise<PageResult<CouponInfo>> {
    biBrow('query.coupons', { fclassid: this.classId });
    if (this.classId === NS.Favorites) {
      return await getFavoritesList(offset, limit);
    }
    return await getListByClassId(this.classId, offset, limit);
  }

  /**
   * 提供比较2个券数据是否相同的方法，供分页组件过滤重复数据
   */
  compareCouponData(couponA: CouponInfo, couponB: CouponInfo) {
    return couponA.couponId === couponB.couponId;
  }

  /**
   * 将数据分2列展示，以实现瀑布流方式(目前纯css没有更好的实现方式)
   */
  groupList(list: CouponInfo[]) {
    const result: MergeCouponListItem[][] = [[], []];
    // 将广告位插入券列表
    const couponListWithAd = getCouponListWithAd({
      list,
      adList: this.adList,
      classId: this.classId,
      isComplete: this.isComplete,
    });
    couponListWithAd.forEach((item, i) => {
      result[i % 2].push(item);
    });

    return result;
  }

  /**
   * 当前分类数据加载完毕后通知父页面
   */
  handlePageComplete() {
    dataLoadCompleteHelper.notify(this);
    this.isComplete = true;
  }

  async beforeCreate() {
    try {
      // 拉取广告
      const { res, isReady } = await handleTimeout({ promise: getAdList() });
      if (res && isReady) {
        this.adList = res;
      }
      this.isShow = true;
    } catch (error) {
      this.isShow = true;
    }
  }

  /**
   * 領券結果
   */
  getCouponAction(result: NotifyActionRet) {
    if (result.name === 'closeCouponDetail') {
      initShare(); // 目前设置的是Channel页分享，这里重置回抢券有so的分享
      return;
    }
    this.$emit('showSubscribeDialog', result);
  }

  /**
   * 展示商户下券列表
   */
  showMerchantDialog(item: MerchantInfoWithAd) {
    this.$emit('showMerchantDialog', item);
  }
  /**
   * 打开好友助力弹窗
   */
  showHelpFriendDialog(couponId: string) {
    this.$emit('showHelpFriendDialog', couponId);
  }
  /**
   * 设置分享信息（券分享，区别于商户分享）
   */
  handleItemClick(item: CouponInfo) {
    const { couponId, couponName } = item;
    const { spId, spLogo, spName } = item.merchantInfo;
    handleCouponShareSetInfo({
      couponName,
      couponId,
      spId,
      spLogo,
      spName,

      adtagPrefix: 'list',
    });
  }

  /**
   * 拉起分享弹框（券分享，区别于商户分享）
   */
  handleDetailShareClick() {
    handleCouponShareShowDialog();
  }
}
